import { FormikErrors } from 'formik'
import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type ErrorMessageProps = {
  error: FormikErrors<unknown> | string | { key: string; values: Record<string, string | number | boolean> } | undefined
}

export default function ErrorMessage(props: ErrorMessageProps) {
  const { error } = props
  const { t } = useTranslation()

  if (!error) return null

  if (typeof error === 'string') return <>{t(error, { defaultValue: error })}</>

  if (!_.has(error, 'key')) throw new Error(`'key' is not defined as property of error object`)

  return <>{t(_.get(error, 'key', ''), _.get(error, 'values'))}</>
}
